import { LogLevel } from "@azure/msal-browser";
import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: '2cd4540a-7363-482b-8443-0152dd0da819',
        authority: 'https://login.microsoftonline.com/043207df-e689-4bf6-9020-01038f11f0b1',
        redirectUri: "/internal-home/",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,

    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
        },
    },
};

// https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
export const loginRequest = {
    scopes: [],
};
